import { ColProps } from "./types";

const Col = ({ children, justify, align, onClick = undefined, className = "", style, gap, dataTestId }: ColProps) => {
  if (!className.includes("w-")) {
    className += " w-full";
  }
  const spicyStyles = `flex flex-col justify-${justify} items-${align} ` + className;

  return (
    <div className={spicyStyles} onClick={onClick} style={{ gap: `${gap}rem`, ...style }} data-testid={dataTestId}>
      {children}
    </div>
  );
};

export default Col;
